import React from 'react';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import { StyledButton } from '../../../Components/Generics.styled';

import { countryCodes, stateCodes, provinceCodes } from '../../../Utils/Consts';

const NavigationSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    width: 350px;
`;

const StyledDropdown = styled.div``;

const LoginTextFieldContainer = styled.div`
    display: flex;
    width: 900px;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
`;

const RowContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    width: 900px;
    justify-content: space-evenly;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const EditAgencyInfoModal = (props) => {
    const {
        agencyInfo,
        setAgencyInfo,
        setModalIsOpen,
        postData,
        modalIsOpen,
        resetFields,
        saveAgencyData,
    } = props;

    const { isLoading } = { ...postData };

    const {
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        city,
        province,
        country,
        zipCode,
        planTypeId,
    } = { ...agencyInfo };

    const handleSave = async () => {
        await saveAgencyData();
        setModalIsOpen(false);
    };

    const handleClose = () => {
        resetFields();
        setModalIsOpen(false);
    };

    const disableNextButton =
        companyName === '' ||
        firstName === '' ||
        lastName === '' ||
        primaryPhone === '' ||
        mobilePhone === '' ||
        streetAddress === '' ||
        city === '' ||
        province === '' ||
        country === '' ||
        planTypeId === '' ||
        zipCode === '';

    const body = (
        <div style={style}>
            <LoginTextFieldContainer>
                <RowContainer>
                    <h1>Update Agency</h1>
                </RowContainer>
                <br />
                <RowContainer>
                    <StyledTextField
                        id="company-name"
                        label="Company Name"
                        defaultValue={companyName}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                companyName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={companyName === ''}
                    />
                    <StyledTextField
                        id="company-website"
                        label="Company Website"
                        defaultValue={companyWebsite}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                companyWebsite: e.target.value,
                            })
                        }
                        variant="outlined"
                    />
                </RowContainer>

                <br />
                <RowContainer>
                    <StyledTextField
                        id="first-name"
                        label="First Name"
                        defaultValue={firstName}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                firstName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={firstName === ''}
                    />
                    <StyledTextField
                        id="last-name"
                        label="Last Name"
                        defaultValue={lastName}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                lastName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={lastName === ''}
                    />
                </RowContainer>

                <br />
                <RowContainer style={{ justifyContent: 'left', marginLeft: '65px' }}>
                    <StyledTextField
                        id="title"
                        label="Your Title"
                        defaultValue={title}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                title: e.target.value,
                            })
                        }
                        variant="outlined"
                    />
                    {/* <StyledDropdown>
              <FormControl required error={planTypeId === ''} variant="outlined">
                <InputLabel id="planType-dropdown">Plan Type</InputLabel>
                <Select
                  style={{ width: '350px' }}
                  labelId="planType-dropdown"
                  id="planType-dropdown"
                  value={planTypeId}
                  onChange={(e) =>
                    setAgencyInfo({
                      ...agencyInfo,
                      planTypeId: e.target.value,
                    })
                  }
                  label="Plan Type"
                >
                  {planTypeData?.map((item, idx) => (
                    <MenuItem key={idx} value={item._id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </StyledDropdown> */}
                </RowContainer>

                <br />
                <RowContainer>
                    <StyledTextField
                        id="primary-phone"
                        label="Primary Phone"
                        defaultValue={primaryPhone}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                primaryPhone: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={primaryPhone === ''}
                    />
                    <StyledTextField
                        id="mobile-phone"
                        label="Mobile Phone"
                        defaultValue={mobilePhone}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                mobilePhone: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={mobilePhone === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '67px' }}>
                    <StyledTextField
                        style={{ width: '765px' }}
                        id="street-address"
                        label="Street Address"
                        defaultValue={streetAddress}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                streetAddress: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={streetAddress === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '67px' }}>
                    <StyledDropdown>
                        <FormControl required error={country === ''} variant="outlined">
                            <InputLabel id="country-dropdown">Country</InputLabel>
                            <Select
                                style={{ marginRight: '10px', width: '240px' }}
                                labelId="country-dropdown"
                                id="country-dropdown"
                                value={country}
                                onChange={(e) =>
                                    setAgencyInfo({
                                        ...agencyInfo,
                                        country: e.target.value,
                                        state: '',
                                    })
                                }
                                label="country"
                            >
                                {countryCodes.map((item, idx) => (
                                    <MenuItem key={idx} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>

                    <StyledTextField
                        style={{ marginRight: '10px', width: '240px' }}
                        id="city"
                        label="City"
                        defaultValue={city}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                city: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={city === ''}
                    />
                    <StyledDropdown>
                        <FormControl
                            disabled={country === ''}
                            required
                            error={country !== '' && province === ''}
                            variant="outlined"
                        >
                            <InputLabel id="state-or-province">
                                {country === 'USA' ? 'State' : 'Province'}
                            </InputLabel>
                            <Select
                                style={{ marginRight: '10px', width: '120px' }}
                                labelId="state-or-province"
                                id="state-or-province"
                                value={province}
                                onChange={(e) =>
                                    setAgencyInfo({
                                        ...agencyInfo,
                                        province: e.target.value,
                                    })
                                }
                                label="state"
                            >
                                {country === 'USA'
                                    ? stateCodes.map((item, idx) => (
                                          <MenuItem key={idx} value={item}>
                                              {item}
                                          </MenuItem>
                                      ))
                                    : provinceCodes.map((item, idx) => (
                                          <MenuItem key={idx} value={item}>
                                              {item}
                                          </MenuItem>
                                      ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>

                    <StyledTextField
                        style={{ width: '133px' }}
                        id="zipcode"
                        label="Zipcode"
                        defaultValue={zipCode}
                        onChange={(e) =>
                            setAgencyInfo({
                                ...agencyInfo,
                                zipCode: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={zipCode === ''}
                    />
                </RowContainer>

                <br />
            </LoginTextFieldContainer>
            <br />
            <br />
            <div>{postData?.error ? 'Somthing went wrong...' : ''}</div>

            <NavigationSection>
                <StyledButton onClick={() => handleClose()} variant="contained" color="primary">
                    Cancel
                </StyledButton>
                <StyledButton
                    disabled={disableNextButton}
                    onClick={() => handleSave()}
                    variant="contained"
                    color="primary"
                >
                    {isLoading ? (
                        <CircularProgress
                            style={{ height: '20px', width: '20px', color: 'white' }}
                            color="primary"
                        />
                    ) : (
                        'Save'
                    )}
                </StyledButton>
            </NavigationSection>

            <EditAgencyInfoModal />
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

EditAgencyInfoModal.propTypes = {
    modalIsOpen: propTypes.bool,
    setModalIsOpen: propTypes.func,
    resetFields: propTypes.func,
    agencyInfo: propTypes.shape({}),
    setAgencyInfo: propTypes.func,
    postData: propTypes.shape({ error: propTypes.bool }),
    saveAgencyData: propTypes.func,
};

EditAgencyInfoModal.defaultProps = {
    modalIsOpen: false,
    setModalIsOpen: () => {},
    saveAgencyData: () => {},
    postData: {},
    setAgencyInfo: () => {},
    agencyInfo: {},
    resetFields: () => {},
};
export default EditAgencyInfoModal;
